var exports = {
  "MY": "OAuthAuthorizePage.module__page___S3B1bm",
  "g4": "OAuthAuthorizePage.module__loadingContainer___S3B1bm",
  "Un": "OAuthAuthorizePage.module__errorContainer___S3B1bm",
  "ow": "OAuthAuthorizePage.module__errorContent___S3B1bm",
  "JU": "OAuthAuthorizePage.module__errorTitle___S3B1bm",
  "kc": "OAuthAuthorizePage.module__errorText___S3B1bm",
  "d1": "OAuthAuthorizePage.module__heroCard___S3B1bm",
  "iC": "OAuthAuthorizePage.module__heroCopy___S3B1bm",
  "ZY": "OAuthAuthorizePage.module__heroTitle___S3B1bm",
  "fd": "OAuthAuthorizePage.module__heroDescription___S3B1bm",
  "$2": "OAuthAuthorizePage.module__cardGrid___S3B1bm",
  "Ql": "OAuthAuthorizePage.module__accountList___S3B1bm",
  "ts": "OAuthAuthorizePage.module__sectionDivider___S3B1bm",
  "nd": "OAuthAuthorizePage.module__panel___S3B1bm",
  "bV": "OAuthAuthorizePage.module__sectionHeader___S3B1bm",
  "Gf": "OAuthAuthorizePage.module__sectionTitle___S3B1bm",
  "yV": "OAuthAuthorizePage.module__sectionDescription___S3B1bm",
  "s0": "OAuthAuthorizePage.module__inlineStatus___S3B1bm",
  "Jb": "OAuthAuthorizePage.module__scopeList___S3B1bm",
  "_9": "OAuthAuthorizePage.module__permissionScrollContainer___S3B1bm",
  "C6": "OAuthAuthorizePage.module__permissionScroller___S3B1bm",
  "Mg": "OAuthAuthorizePage.module__permissionList___S3B1bm",
  "ce": "OAuthAuthorizePage.module__permissionRow___S3B1bm",
  "Ck": "OAuthAuthorizePage.module__permissionLabel___S3B1bm",
  "rJ": "OAuthAuthorizePage.module__scopeRow___S3B1bm",
  "BB": "OAuthAuthorizePage.module__scopeHeading___S3B1bm",
  "OK": "OAuthAuthorizePage.module__scopeName___S3B1bm",
  "RJ": "OAuthAuthorizePage.module__scopeDescription___S3B1bm",
  "Pp": "OAuthAuthorizePage.module__scopeChip___S3B1bm",
  "p$": "OAuthAuthorizePage.module__emptyState___S3B1bm",
  "uL": "OAuthAuthorizePage.module__caution___S3B1bm",
  "iB": "OAuthAuthorizePage.module__dangerNotice___S3B1bm",
  "mW": "OAuthAuthorizePage.module__successScreen___S3B1bm",
  "n7": "OAuthAuthorizePage.module__successIconCircle___S3B1bm",
  "FU": "OAuthAuthorizePage.module__successIcon___S3B1bm",
  "QK": "OAuthAuthorizePage.module__successTitle___S3B1bm",
  "s3": "OAuthAuthorizePage.module__successSubtitle___S3B1bm",
  "cs": "OAuthAuthorizePage.module__successAction___S3B1bm",
  "By": "OAuthAuthorizePage.module__guildOption___S3B1bm",
  "rZ": "OAuthAuthorizePage.module__guildValue___S3B1bm",
  "XN": "OAuthAuthorizePage.module__guildAvatar___S3B1bm",
  "oM": "OAuthAuthorizePage.module__guildAvatarPlaceholder___S3B1bm",
  "p2": "OAuthAuthorizePage.module__guildOptionLabel___S3B1bm",
  "RG": "OAuthAuthorizePage.module__guildOptionDisabled___S3B1bm",
  "p4": "OAuthAuthorizePage.module__guildOptionNotice___S3B1bm",
  "A2": "OAuthAuthorizePage.module__actionSection___S3B1bm",
  "PJ": "OAuthAuthorizePage.module__footerText___S3B1bm",
  "o1": "OAuthAuthorizePage.module__actions___S3B1bm",
  "hP": "OAuthAuthorizePage.module__actionButton___S3B1bm",
};

module.exports = exports;
